export default __webpack_public_path__ + "static/media/general2024-4.ef053791.gif";